export default "__VITE_ASSET__672Wq7cc__"